module.exports = __webpack_public_path__ + "static/img/slide_9_fr.2cff15f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_9_fr.svg
// module id = DcIV
// module chunks = 0